import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4e2312ac"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container-seo-page"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "custom-control custom-checkbox"
};
const _hoisted_5 = ["checked", "indeterminate"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_error_occured = _resolveComponent("error-occured");
  const _component_seo_edit_item_new = _resolveComponent("seo-edit-item-new");
  const _component_app_table_head_seo = _resolveComponent("app-table-head-seo");
  const _component_seo_row = _resolveComponent("seo-row");
  const _component_b_tbody = _resolveComponent("b-tbody");
  const _component_b_table_simple = _resolveComponent("b-table-simple");
  const _component_app_modal = _resolveComponent("app-modal");
  const _component_edit_text_modal = _resolveComponent("edit-text-modal");
  const _component_image_manager_modal = _resolveComponent("image-manager-modal");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.errorOccured ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_error_occured, {
    onRetry: _ctx.refreshSellers
  }, null, 8, ["onRetry"])])) : _createCommentVNode("", true), !$data.errorOccured ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "container-seo-page-flex-child",
    ref: "seo-table-content",
    onScroll: _cache[6] || (_cache[6] = (...args) => $options.HidePopover && $options.HidePopover(...args)),
    onScrollend: _cache[7] || (_cache[7] = (...args) => $options.ShowPopover && $options.ShowPopover(...args))
  }, [$data.editSingleItem ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_seo_edit_item_new, {
    modelValue: $data.editSingleItem,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.editSingleItem = $event),
    onBack: $options.onEditSingleItemBack,
    onSubmit: _ctx.onSubmitSingleItem,
    content_id: $data.editContentId,
    content_amazon_link: $data.editContentLink
  }, null, 8, ["modelValue", "onBack", "onSubmit", "content_id", "content_amazon_link"])])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "custom-table-wrapper",
    ref: "seo-table",
    tabindex: "0",
    onMouseover: _cache[4] || (_cache[4] = (...args) => $options.keepFocus && $options.keepFocus(...args)),
    onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers((...args) => $options.keydownEscHandler && $options.keydownEscHandler(...args), ["prevent"]), ["esc"]))
  }, [_createVNode(_component_b_table_simple, {
    id: "content-table",
    class: "custom-table table-graph content-optimization-table",
    "sticky-header": "",
    responsive: "",
    striped: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_app_table_head_seo, {
      fields: $options.tableFields,
      "sort-by": $data.sortBy,
      "onUpdate:sortBy": _cache[2] || (_cache[2] = $event => $data.sortBy = $event),
      "sort-desc": $data.sortDesc,
      "onUpdate:sortDesc": _cache[3] || (_cache[3] = $event => $data.sortDesc = $event),
      onExpandImageList: $options.expandImageList,
      onCollapseImageList: $options.collapseImageList
    }, {
      select: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("input", {
        type: "checkbox",
        class: "custom-control-input",
        id: "selectAll",
        checked: $data.selectAll,
        indeterminate: $data.indeterminate,
        onChange: _cache[1] || (_cache[1] = $event => $options.toggleSelectAll($event.target.checked))
      }, null, 40, _hoisted_5)])]),
      _: 1
    }, 8, ["fields", "sort-by", "sort-desc", "onExpandImageList", "onCollapseImageList"]), $options.tableItems.length > 0 ? (_openBlock(), _createBlock(_component_b_tbody, {
      key: 0
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.tableItems, (item, index) => {
        return _openBlock(), _createBlock(_component_seo_row, {
          item: item,
          key: item.content_id,
          index: index,
          selected_contents: _ctx.selected_contents,
          pushModal: _ctx.pushModal,
          push_loading: $options.isPushLoading(item),
          isCheckBoxDisabled: !_ctx.isPossibleToPush(item),
          onOnEdit: params => $options.onEdit(params.item, params.type, params.title),
          isImageCellCollapsed: $data.isCollapsedImageList,
          onOnEditSingleItem: $options.onEditSingleItem,
          onOnConfirmPushSingleContent: $options.handlePushItem,
          onIsCopied: $options.isCopied,
          isCopying: _ctx.is_copying,
          onOnPaste: params => $options.onPaste(params.item, params.type, params.title),
          onExpandImageList: $options.expandImageList,
          onSelectItem: params => $options.selectItem(params.$event, params.item),
          showPopover: $data.showPopover
        }, null, 8, ["item", "index", "selected_contents", "pushModal", "push_loading", "isCheckBoxDisabled", "onOnEdit", "isImageCellCollapsed", "onOnEditSingleItem", "onOnConfirmPushSingleContent", "onIsCopied", "isCopying", "onOnPaste", "onExpandImageList", "onSelectItem", "showPopover"]);
      }), 128))]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  })], 544)], 544)) : _createCommentVNode("", true), _createVNode(_component_app_modal, {
    modelValue: $data.confirmPushSingleContent,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.confirmPushSingleContent = $event),
    title: "Confirm Push Content",
    "cancel-title": "No",
    "ok-title": "Yes",
    onOk: _cache[9] || (_cache[9] = $event => _ctx.onPushModalSubmit([$data.singleContentToPush.content_id]))
  }, {
    default: _withCtx(() => [_createTextVNode(" Are you sure you want to push content for " + _toDisplayString($data.singleContentToPush.product_name) + " " + _toDisplayString($data.singleContentToPush.asin) + " " + _toDisplayString($data.singleContentToPush.sku) + " ? ", 1)]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_app_modal, {
    modelValue: $data.confirmPushSelectedContent,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.confirmPushSelectedContent = $event),
    title: "Confirm Push Selected Content",
    "cancel-title": "No",
    "ok-title": "Yes",
    onOk: _cache[11] || (_cache[11] = $event => $options.onPushModalSubmitModifiedContent())
  }, {
    default: _withCtx(() => [_createTextVNode(" Are you sure you want to push the selected content ? ")]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_edit_text_modal, {
    modelValue: $data.editTextModal,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.editTextModal = $event),
    value: $data.editValue,
    original: $data.editOriginal,
    type: $data.type,
    title: $data.title,
    allowHtmlInputAndSpecialCharacters: $options.allowHtmlInputAndSpecialCharacters,
    image: $data.editImage,
    name: $data.editProductName,
    asin: $data.editAsin,
    marketplace_id: _ctx.editMarketplaceId,
    sku: $data.editSku,
    item_highlight: $data.editItemHighlight,
    description: _ctx.editDescription,
    bullet_points: _ctx.editBulletPoints,
    content_id: $data.editContentId,
    show_accept_amazon: $data.showAcceptAmazon,
    size: "lg",
    onUpdate: $options.onUpdate,
    onSubmit: $options.onSubmit,
    onClose: $options.onCloseEdit
  }, null, 8, ["modelValue", "value", "original", "type", "title", "allowHtmlInputAndSpecialCharacters", "image", "name", "asin", "marketplace_id", "sku", "item_highlight", "description", "bullet_points", "content_id", "show_accept_amazon", "onUpdate", "onSubmit", "onClose"]), _createVNode(_component_image_manager_modal, {
    modelValue: $data.imageManagerModal,
    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.imageManagerModal = $event),
    image: $data.editImage,
    size: "lg",
    onUpdate: $options.onImageUpdate,
    onSubmit: $options.onImageSubmit
  }, null, 8, ["modelValue", "image", "onUpdate", "onSubmit"])]);
}